// extracted by mini-css-extract-plugin
module.exports = {"tags":"bp-1OXOgnU71-zAddGgQ"};